/**
 * Fixed set of reasons the practice may attach when declining a patient's
 * pending-hold self-booking (PRD #1343, user story 29). No free text — a
 * decline must never become an unstructured channel, and the patient sees the
 * reason verbatim. German labels live in the frontend; the stored values are
 * stable English codes. Distinct from {@link CancellationReason}, which is the
 * patient-side set for their own cancellations/withdrawals.
 */
export var BookingDeclineReason;
(function (BookingDeclineReason) {
    /** Der gewünschte Termin ist nicht mehr verfügbar. */
    BookingDeclineReason["SLOT_UNAVAILABLE"] = "SLOT_UNAVAILABLE";
    /** Wir haben aktuell keine freie Kapazität. */
    BookingDeclineReason["NO_CAPACITY"] = "NO_CAPACITY";
    /** Die gewünschte Therapeut:in ist nicht verfügbar. */
    BookingDeclineReason["THERAPIST_UNAVAILABLE"] = "THERAPIST_UNAVAILABLE";
    /** Bitte kontaktiere die Praxis für Rückfragen. */
    BookingDeclineReason["OTHER"] = "OTHER";
})(BookingDeclineReason || (BookingDeclineReason = {}));
//# sourceMappingURL=booking-decline-reason.enum.js.map